import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, RISKMGT } from '@const'
import * as utils from '@utils'
import Table from '@tables/table'
import EditContinuousLossDialog from '@risk/edit-continuous-loss-dialog'
import { Grid } from '@material-ui/core'
import PfSubPfSelect from '@select/pf-sub-pf-select'
import { RISK_LABEL_CONTINUOUS_LOSING } from '@const/risk-manager'
import { addToast } from '../../../utils/toast'
import { getCodeMsg } from '../../../utils/translation'
const COMPONENT_GROUP = 'default_rtp_setting'
class ContinuousLossSettingPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'ContinuousLossSettingPage')
        }
    }

    state = {}

    columns = [
        {
            field: 'pf_sub_pf_id',
            type: 'platform',
        },
        {
            field: 'oid',
        },
        {
            field: 'game_code',
        },
        {
            field: 'game_name',
            translate: {
                dataKey: 'game_code',
                tranKey: 'GameName',
            },
        },
        {
            field: 'claim_in_rounds',
            render: (rowData) => rowData['claim_in_rounds'].join(' ~ '),
        },
    ]

    componentDidMount() {
        if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
            this.columns.push({
                field: 'edit',
                type: 'edit',
                component: this.editDialog,
            })
        }
    }

    queryData() {
        if (utils.checkValid(COMPONENT_GROUP + '.view')) {
            this.table.SetLoading(true)
                utils.apiRequest(
                    'get',
                    API.RISKMGT_GAME_RISK_INFO_LIST,
                    {
                        risk_label_list: [RISK_LABEL_CONTINUOUS_LOSING].join(),
                        pf_sub_pf_id: this.pfSelect.state.pfSubPfId,
                    },
                    (data) => {
                        const tempList = []
                        for (const idx in data) {
                            if (data[idx].risk_label !== RISKMGT.RISK_LABEL_CONTINUOUS_LOSING) {
                                continue
                            }
        
                            tempList.push(data[idx])
                        }
        
                        this.table.SetData(tempList)
                    },
                    (_err) => {
                        this.table.SetData([])
                    },
                    true
                )
        } else {
            this.table.SetData([])
            addToast(getCodeMsg(30011), 'error')
        }
    }

    render() {
        return (
            <Grid container spacing={2}>
                <PfSubPfSelect
                    onRef={(ref) => (this.pfSelect = ref)}
                    options={{
                        hideCurrency: true,
                        hideAllSubPlatform: true,
                        subPfChangeCallback: () => {
                            this.queryData()
                        },
                    }}></PfSubPfSelect>
                <Grid item xs={12}>
                    <Table
                        ownerName="ContinuousLossSettingPage"
                        columns={this.columns}
                        options={{
                            orderIdx: 1,
                        }}
                        onRef={(ref) => (this.table = ref)}
                    />
                    <EditContinuousLossDialog
                        confirmCallback={() => {
                            this.queryData()
                        }}
                        onRef={(ref) => (this.editDialog = ref)}
                    />
                </Grid>
            </Grid>
        )
    }
}

const styles = (_theme) => {
    return {}
}

ContinuousLossSettingPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default hoc(styles)(ContinuousLossSettingPage)
